import { Component, OnInit, ChangeDetectorRef,  ViewChild } from '@angular/core';
import {  FacilityService, TicketsService, BatchService, WorktypeService, MessageService, PayrollCodeService } from 'src/app/services/'
import { UserDetail, TicketDetails, AccessUserInfo } from 'src/app/models'
import { SelectItem } from 'primeng/api/selectitem';
import { TicketInfoComponent } from '../ticketInfo/ticket-info.component'
import { BatchTicketInfoComponent } from '../batchTicketInfo/batch-ticket-info.component'
import { CreateTicketFormFields } from 'src/app/models/tickets/createTicketFormFields'
import { BartTicketValidate } from 'src/app/models/tickets/bart.ticket.validate'
import { BartTicket } from 'src/app/models/tickets/bart.ticket'
import { TicketStatus } from 'src/app/enum/ticket/ticket-status.enum'
import { ActivatedRoute } from '@angular/router';
import { BartTicketSave } from 'src/app/models/tickets/bart.ticket.save'
import { DatePipe } from '@angular/common'
import { ConfirmationService } from 'primeng/api';
import {  CurrencyPipe} from '@angular/common';
@Component({
  selector: 'bart-ticket-main',
  templateUrl: './ticket-main.component.html',
  styleUrls: ['./ticket-main.component.scss'],
  providers: [BartTicket, BartTicketSave]
})
export class TicketMainComponent implements OnInit {
  datePiepe = new DatePipe('en-US')
  @ViewChild(TicketInfoComponent, { static: false }) ticketInfoComponent: TicketInfoComponent;
  @ViewChild(BatchTicketInfoComponent, { static: false }) batchTicketInfoComponent: BatchTicketInfoComponent;
  public formFields: CreateTicketFormFields;
  public userInfo: UserDetail;
  public locdbData: any
  public divisionList: SelectItem[];
  public regionList: SelectItem[];
  public facilityList: SelectItem[];
  public batchList: SelectItem[];
  public workTypeList?: SelectItem[];
  public allWorkTypeList?: any[];
  public ticketId: string = null;
  public minutes: SelectItem[];
  paydata: SelectItem[];
  hours: SelectItem[];
  public showGlobalLoader:boolean=false;
  public showLocationLoader=false
  constructor
    ( 
      private _faciliService: FacilityService,
      private _ticketService: TicketsService,
      private _batchService: BatchService,
      private _workTypeService: WorktypeService,
      private changeDetectorRef: ChangeDetectorRef,
      public tkValidation: BartTicketValidate,
      private _bartTicketSave: BartTicketSave,
      private route: ActivatedRoute,
      private _payrollCodeService: PayrollCodeService,
      private _confirmationService: ConfirmationService,
      private _messageService: MessageService,
      private currencyPipe : CurrencyPipe
  ) {
    this.formFields = new CreateTicketFormFields()
    this._ticketService.setTicketGlobalData(this.formFields)
    this.userInfo = AccessUserInfo.getUserInfo();
    //this.tkValidation=new BartTicketValidate(_ticketService);

  }

  ngOnInit() {
    this.showLocationLoader=true
    this.ticketId = this.route.snapshot.paramMap.get('ticketId');
    if(this.ticketId!=null && this.ticketId!=undefined)
    {
      this.showGlobalLoader=true
    }
    this.populateBatches();
    this.loadAllWorkType(()=>
    {
      this.GetUserLocations();
    });
   
    this._ticketService.getTicketGlobalData().subscribe((Result: any) => {
      this.formFields = Result;
    },
      (error) => {
        console.log(error);
      }
    );
    
    this.formFields.partTotalAmount = this.currencyPipe.transform(0, '$');
  }
  private GetUserLocations() {
    let getLocationParam = {
      "GETUSERLOCATIONS": {
        LOCATION_ID_LIST: null,
        USERNAME: this.userInfo.userName,
      },
      "GETUSERLOCATIONS2": {
        USERNAME: this.userInfo.userName,
      }
    }
    if (getLocationParam != null) {
      this._faciliService.getUserLocations(JSON.stringify(getLocationParam))
        .subscribe((allUserLocationsResponse: any) => {
          this.showLocationLoader=false
          this.locdbData = allUserLocationsResponse;
          this.populateDivisions();
          
          if (this.ticketId != null)
            this.getTicketData(this.ticketId);
        }, (error) => {
          this.divisionList = [];
          this.regionList = [];
          this.facilityList = [];
          console.log(error);
          this.showGlobalLoader=false
          this.showLocationLoader=false
        }
        );
    }

    this.hours = [];
    for (let i = 0; i <= 24; i++) {
      let j = 0;
      if (i <= 9) {
        this.hours.push({ label: j + i.toString(), value: i });
      }
      else { this.hours.push({ label: i.toString(), value: i }); }

    }
    this.minutes = [];
    this.minutes.push({ label: "00", value: 0 }, { label: "15", value: 25 }, { label: "30", value: 50 }, { label: "45", value: 75 });
    this.formFields.hoursWorkedSel = Number(0);
    this.formFields.hoursTravelSel = Number(0);
    this.formFields.minutesTravelSel = Number(0);
    this.formFields.minutesWorkedSel = Number(0);

    this.getPayrollCodes();
  }
  //**************************Bind Division DropdownList******************************* */
  populateDivisions() {
    this.divisionList = [];
    if (this.locdbData.divisions.length > 0) {
      this.divisionList = this.locdbData.divisions.map(data => ({
        label: data.DivisionName,
        value: data.DivisionMasterID,
      }));
    }

  }
  //*************************Division Change Event*****************************************
  populateRegions(divisionMasterID) {
    this.regionList = [];
    this.formFields.selectedRegionId = null
    this.resetColumn()
    if (this.locdbData.regions.length > 0) {
      this.regionList = this.locdbData.regions.filter(x => x.DivisionMasterID == divisionMasterID).map(data => ({
        label: data.RegionName,
        value: data.RegionMasterID,
      }));
    }
    if (divisionMasterID && this.divisionList.find(x => x.value == divisionMasterID)) {
      this.formFields.selectedDivisionName = this.divisionList.find(x => x.value == divisionMasterID).label
    }
    //this._ticketsService.setData("any data that you want push to child");
  }
  //********************************Region Changed Event***************************************
  populateFacilities(regionMasterID) {
    this.formFields.selectedFacilityId = null
    this.resetColumn();
    this.facilityList = [];
    if (this.locdbData.regions.length > 0) {
      this.facilityList = this.locdbData.facilities.filter(x => x.RegionMasterID == regionMasterID).map(data => ({
        label: data.FacilityDisplayName,
        value: data.FacilityMasterID,
      }));
    }

    if (regionMasterID && this.regionList.find(x => x.value == regionMasterID)) {
      this.formFields.selectedRegionName = this.regionList.find(x => x.value == regionMasterID).label
    }
    this.facilityChanged();
  }
  //********************************Facility Changed Event***************************************
  facilityChanged(eventId: string = "0") {
    if (this.formFields.selectedFacilityId && this.facilityList.find(x => x.value == this.formFields.selectedFacilityId)) {
      this.formFields.selectedFacilityName = this.facilityList.find(x => x.value == this.formFields.selectedFacilityId).label
    }
    this.formFields.isNewTicket = false;
    if (this.formFields.ticketNumber == null || this.formFields.ticketNumber == "") {
      this.formFields.isNewTicket = true;
    }
    this.refreshWorkType()
    this.clearEquipmentList();
    this.formFields.selectedWorkTypeId = null;
    this.formFields.batchRadioButtonselectedValue = null
    this.createBatchRadioClick();
  }
  //#region Batch Section
  public createBatchRadioClick() {
    this.formFields.clockHours = null;
    this.formFields.selectedBatchId = null;
    this.formFields.additionalComment="";
    this.formFields.isShowAdditionalComment==false;
    this.formFields.ScheduledRadioButtonselectedValue = null
    this.formFields.selectedWorkTypeId = null
    this.workTypeList = null
    if (this.formFields.batchRadioButtonselectedValue == 1) {
      this.formFields.isBatchTicket = true;
    }
    else {
      this.formFields.isBatchTicket = false;
      this.formFields.ScheduledRadioButtonselectedValue = null;
      this.formFields.selectedWorkTypeId = null;
      this.formFields.isBatchTicket = false;
    }

    this.workTypeChanged();
    this.fillBatchEquipmentList()
  }
  public fillBatchEquipmentList() //Batch Changed Event Here
  {
    if (this.ticketId == null || this.ticketId == undefined) {
      this.formFields.batchDetails = null;
      this.formFields.batchMeasure = null;
      this.formFields.batchPart = null;
      this.formFields.selectedBatchEquipmentList = null;
      this.formFields.batchTicketObj = null
      this.formFields.isBatchTicket = false
      this.formFields.isShowBatchLabour = false;
      //Start:Added By Satheesh 24-June-2020
      this.formFields.hoursWorkedSel = Number(0);
      this.formFields.hoursTravelSel = Number(0);
      this.formFields.minutesTravelSel = Number(0);
      this.formFields.minutesWorkedSel = Number(0);
      this.formFields.partsUsedDuringRepair = null;
      this.formFields.testEquipmentUsedDuringRepair = null
      this.formFields.ispartsUsedRadio = null;
      this.formFields.istestEquipUsedRadio = null;
      //end:Added By Satheesh
      this.loadBatchDetails();
    }
  }
  public selectBatch() //TBD
  {
    this.formFields.selectedWorkTypeId = null
    this.processWorkTypes();
  }
  public populateBatches() {
    let GETBATCHES = {
      "GETBATCHESDD": {
        BatchId: null,
      }
    }
    var request = JSON.stringify(GETBATCHES);

    this.batchList = [];
    if (GETBATCHES != null) {
      this._batchService.getBatchesDD(request)
        .subscribe((response: any) => {
          if (response.batches.length > 0) {
            this.batchList = response.batches.map(data => ({
              label: data.BatchName,
              value: data.BatchId,
            }));
          }
        },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  public selectNextBatchForm() {

  }
  //#endregion BatchSection

  //#region Work Type
  getWorkTypeParam = {
    "GETWORKTYPES": {
      WorkTypeId: null,
      isScheduledFlag: null,
      isUnscheduledFlag: null,
      isCanBatchFlag: null
    }
  }
  public loadAllWorkType(callBack) {

    this.workTypeList = [];
    if (this.getWorkTypeParam != null) {
      var GETWORKTYPES = this.getWorkTypeParam;
      this._workTypeService.getWorkTypes(JSON.stringify(GETWORKTYPES))
        .subscribe((response: any) => {
          if (response.length > 0) {
            this.allWorkTypeList = response
            callBack()
          }
        },
          (error) => {
            console.log(error);
            this.allWorkTypeList=[]
            callBack()
          }
        );
    }
  }

  public populateWorkTypeV2(isScheduledFlag, isUnscheduledFlag, isCanBatchFlag) {

    this.workTypeList = [];
    this.formFields.selectedWorkTypeId = null
    this.workTypeChanged();
    if (this.allWorkTypeList.length > 0) {
      this.workTypeList = this.allWorkTypeList.map(data => ({
        label: data.WorkTypeCode,
        value: data.WorkTypeId,
      }));
    }
  }

  public populateWorkType()//ScheduledRadioButton Click Event
  {
    if (this.formFields.isServiceTypeBoxDisabled)
      return false;

    this.workTypeList = [];

    this.formFields.selectedWorkTypeId = null
    let sflag: string = null
    let usflag: string = null
    let isCanBatchFlag: string = null
    this.workTypeChanged();
    if (this.formFields.ScheduledRadioButtonselectedValue == "yes") {
      sflag = "1"
    }
    else {
      usflag = "1"
    }
    if (this.formFields.isCanBatchFlag == undefined || this.formFields.isCanBatchFlag == null || this.formFields.isCanBatchFlag == false) {
      isCanBatchFlag = "0";
    }
    if (usflag == "1") {
      isCanBatchFlag = null;
    }
    if (this.allWorkTypeList.length > 0) {
      this.getWorkTypeParam.GETWORKTYPES.WorkTypeId = null;
      this.getWorkTypeParam.GETWORKTYPES.isCanBatchFlag = isCanBatchFlag;
      this.getWorkTypeParam.GETWORKTYPES.isScheduledFlag = sflag;
      this.getWorkTypeParam.GETWORKTYPES.isUnscheduledFlag = usflag;
      var GETWORKTYPES = this.getWorkTypeParam;
      this._workTypeService.getWorkTypes(JSON.stringify(GETWORKTYPES))
        .subscribe((response: any) => {
          if (response.length > 0) {
            this.workTypeList = response.map(data => ({
              label: data.WorkTypeCode,
              value: data.WorkTypeId,
            }));
          }
        },
          (error) => {
            console.log(error);
          }
        );
    }
  }
  public workTypeChanged() {
    this.formFields.isServiceTypeBoxDisabled = false
    if (this.formFields.selectedWorkTypeId && this.workTypeList.find(x => x.value == this.formFields.selectedWorkTypeId)) {
      this.formFields.selectedWorkTypeName = this.workTypeList.find(x => x.value == this.formFields.selectedWorkTypeId).label
    }
    //console.log(this.formFields.selectedWorkType);
    this.clearEquipmentList();
    this.showEquipmentList();

  }
  public refreshWorkType() {
    if (this.formFields.selectedWorkTypeId != null) {
      this.workTypeChanged();
    }
  }
  public processWorkTypes() {
    let workTypeId = this.formFields.selectedWorkTypeId;
    try {

      let cuurentWorkTypeDetails = this.allWorkTypeList.find(x => x.WorkTypeId == workTypeId);
      if (cuurentWorkTypeDetails) {

        let isBatchFlag = cuurentWorkTypeDetails.IsCanBatchFlag;
        var isCanCloneFlag = cuurentWorkTypeDetails.IsCanCloneFlag;
        // var isScheduledFlag = cuurentWorkTypeDetails.IsScheduledFlag;
        // var IsUnscheduledFlag = cuurentWorkTypeDetails.IsUnscheduledFlag;
        //   if(isScheduledFlag==1)
        //   {
        //     this.formFields.ScheduledRadioButtonselectedValue="yes";
        //   }
        //  else if(IsUnscheduledFlag==1)
        //   {
        //     this.formFields.ScheduledRadioButtonselectedValue="no";
        //   }
        //   this.populateWorkType();
        if (isCanCloneFlag == undefined || isCanCloneFlag == null || isCanCloneFlag == "") {
          isCanCloneFlag = 0;
        }

        // if (this.formFields.batchRadioButtonselectedValue==1) {
        //   this.formFields.isBatchTicket = true;
        // }
        // if (this.formFields.selectedBatchId >0) {
        //   this.formFields.isBatchTicket = true;
        // }
        // if (this.formFields.batchDetails && this.formFields.batchDetails.BatchId && this.formFields.batchDetails.BatchId>0) {
        //   this.formFields.isBatchTicket = true;
        // }
        this.formFields.isCloneFlag = isCanCloneFlag;
        this.formFields.isCanBatchFlag = isBatchFlag;
        // if (this.formFields.batchDetails && this.formFields.batchDetails.BatchId && this.formFields.batchDetails.BatchId>0) 
        // {
        //   this.formFields.isServiceTypeBoxDisabled=true
        //   console.log(this.formFields.batchDetails)
        //   ;

        // }
      }
      //this.formFields.selectedWorkTypeId=workTypeId
    }
    catch (ex) {
      console.log(ex)
    }


  }
  //#endregion WorkType
  /////////////////////////////////////////		DATE SERVICE REQUESTED			/////////////////////////////////////////
  public dateServiceRequestedChanged() {

    if (this.formFields.isBatchTicket == false) {
      this.tkValidation.validateColumn1(true);
    }
  }

  /////////////////////////////////////////		DATE SERVICE BEGAN				/////////////////////////////////////////
  public dateServiceBeganChanged() {
    if (this.formFields.isBatchTicket == false) {
      this.tkValidation.validateColumn1(true);
    }
    if (this.ticketInfoComponent != null) {
      this.ticketInfoComponent.showLabour();
    }
  };

  /////////////////////////////////////////		ACTUAL SERVICE DATE				/////////////////////////////////////////
  public dateServicePerformedChanged() {
    if (this.formFields.isBatchTicket == false) {
      this.tkValidation.validateColumn1(true);
      
      if (this.ticketInfoComponent != null) {
        this.ticketInfoComponent.getQuestions();
      }
    }
  };
  //#region equipmentList
  public resetEquipmentData() {
    if (this.formFields.isBatchTicket) {
      //$('#batchEquipGrid').clearGridData();
      //$("#batchEquipment").hide();
      this.selectBatch();
    }
    else {

    }

  }
  public clearSeletedEquipmentButtonClicked() {
    this.formFields.selectedEquipmentList = null;
    this.formFields.srBeginDate = null;
    this.formFields.srCompletedDate = null;
    if (!this.formFields.isDateServiceRequestedDisabled) {
      this.formFields.srRequestedDate = null;
    }
    this.clearEquipmentList();
    this.showEquipmentList();
    this.ticketInfoComponent.selectedEquipmentData=[];
  }
  public clearEquipmentList() {
    this.formFields.selectedEquipmentList = null;
    if (this.ticketId == null && this.ticketId == undefined) {

      this.formFields.srBeginDate = null;
      this.formFields.srCompletedDate = null;
      if (!this.formFields.isDateServiceRequestedDisabled) {
        this.formFields.srRequestedDate = null;
      }
    }
    this.resetEquipmentData()
  }
  ////#endregion

  public resetColumn() {
    this.clearEquipmentList();
    this.formFields.selectedFacilityId = null
    this.formFields.batchRadioButtonselectedValue = null
    this.formFields.selectedBatchId = null
    this.formFields.ScheduledRadioButtonselectedValue = null
    this.formFields.selectedWorkTypeId = null
    this.formFields.isShowColumn2 = false
    this.formFields.isShowColumn3 = false;
    //$("#equipmentPicker,#batchBox,#batchBoxSelect,#serviceTypeBox,#workTypeId,#equipServicedBox,#dateBox").hide();
  }
  //Call Ticket Info (Child Component) components Here
  public showEquipmentList() {
    if (this.ticketInfoComponent != null && (this.formFields.selectedWorkTypeId != null || this.formFields.selectedBatchId != null)) {
      this.formFields.isShowColumn2 = false
      this.formFields.isShowColumn3 = false
      this._ticketService.setTicketGlobalData(this.formFields)
      if(this.formFields.selectedFacilityId)
      {
        this.ticketInfoComponent.showEquipmentList()
      }
    }
  }

  //#region  bart.ticket.load.js Code Here
  //================================================================================================================================================
  //=======================================================Bart.Ticket.Load=============================================================
  public getTicketData(ticketId) {
    let tickObj: TicketDetails;
    let getTicketDetailParam =
    {
      "GETTICKET": {
        UserID: this.userInfo.userId,
        BartRoleID: this.userInfo.bartRoleId,
        TicketID: ticketId
      }

    }
    this._ticketService.getTicket(JSON.stringify(getTicketDetailParam)).subscribe(data => {
      if (data != null && data.length > 0) {
        tickObj = data.find(x => x.ticketId == ticketId);
        this.populateTicketDetails(tickObj)
        this.showGlobalLoader=false
      }
    },
      (error) => {
        tickObj = null;
        console.log(error);
        this.showGlobalLoader=false
      });
  }
  public populateTicketDetails(obj: TicketDetails) {
    if (obj == null) {
      this._messageService.showAlertMessage('cannot find ticket ' + this.ticketId)
      return false;
    }
    this.formFields.isNewTicket = false;
    this.formFields.ticketStatusId = obj.ticketStatusId
    this.formFields.TicketId = obj.ticketId;
    this.formFields.isShowColumn2 = true;//$('#column2').show();
    this.formFields.isShowColumn3 = true;//$('#column3').show();
    this.formFields.ticketNumber = obj.ticketNumber; 
    
    //IF THE USER IS NOT THE TICKET OWNER DISABLE THE ABILITY TO MODIFY
    if (this.userInfo.userId != obj.createdBy) {
      this.formFields.isValidTicketUser = false
    };
    this.loadTicketParts(this.formFields.TicketId);
    this.loadTicketTestEquip(this.formFields.TicketId);
    //TICKET ALREADY CLOSED LET'S SHOW THE SUMMARY
    if (obj.ticketStatusId == TicketStatus.Closed) {

      if (obj.isBatchFlag) {
        //#region Create BatchTicketObject
        this.formFields.selectedBatchId = obj.BatchId;
        this.loadBatchDetails()
        this.formFields.batchTicketObj =
          [
            {
              sqaCode: Number(obj.sqaCode),
              networkSurveyA: obj.networkSurveyA,
              networkSurveyC: obj.networkSurveyC,
              networkSurveyB: obj.networkSurveyB,
              networkSurveyE: obj.networkSurveyE,
              networkSurveyD: obj.networkSurveyD,
              isServiceMatchFindingsFlag: obj.isServiceMatchFindingsFlag,
              dateServiceBegan: obj.DateServiceBegan,
              equipmentId: obj.equipmentId,
              sqaSubCodeId: obj.SQASubCodeId,
              serviceRequested: obj.serviceRequested,
              clockHours: obj.ClockHours,
              dateServiceRequested: obj.DateServiceRequested,
              dateServicePerformed: obj.DateServicePerformed,
              waterFrequency: obj.waterFrequency,
              groundWireResistance: obj.GroundWireResistance,
              workTypeId: obj.workTypeId,
              batchId: obj.BatchId,
              electricalLeakage: obj.ElectricalLeakage,
              hoursWorkPerTicket: obj.HoursWork,
              ticketStatusId: obj.ticketStatusId,
              ticketId: obj.ticketId,
              payrollCodeId: obj.PayrollCodeID,
              manufacturerName: obj.manufacturerName,
              ticketNumber: obj.ticketNumber,
              waterTemperatureVolume: obj.waterTemperatureVolume,
              waterTemperature: obj.waterTemperature,
              hoursTravel: obj.HoursTravel,
              isUnscheduledFlag: 0,
              additionalComments: obj.additionalComments,
              workPerformed: obj.WorkPerformed,
              facilityMasterId: obj.facilityMasterId,
              waterVolume: obj.waterVolume,
              isBatchFlag: obj.isBatchFlag,
              hoursWork: obj.HoursWork,
              equipmentSerialNumber: obj.equipmentSerialNumber,
              hoursTravelPerTicket: obj.HoursTravel,
              waterVolumeMonthly: obj.waterVolumeMonthly,
              totalHoursPerTicket: obj.HoursWork+obj.HoursTravel,
              waterDurationA: obj.waterDurationA,
              waterDurationB: obj.waterDurationB,
              isCloneFlag: obj.isCloneFlag,
              waterDurationE: obj.waterDurationE,
              waterDurationC: obj.waterDurationC,
              waterDurationD: obj.waterDUrationD,
              meritComplaint: null,
              ticketCount: 1,
              isScheduledFlag: obj.isScheduledFlag,
              modelDescription: obj.modelDescription,
              covidAttestationA: obj.covidAttestationA,
              covidAttestationB: obj.covidAttestationB,
              covidAttestationC: obj.covidAttestationC,
              GeneralSoftware: obj.GeneralSoftware,
              Actuator: obj.Actuator,
              Functional: obj.Functional,
            }
          ]
        setTimeout(() => {
          this.formFields.isShowBatchTicketSummary = true
          this.formFields.isShowTicketSummary = false
        }, 1000);
      }
      else {
        setTimeout(() => {
          this.formFields.isShowTicketSummary = true
          this.formFields.isShowBatchTicketSummary = false
        }, 1000);
      }


      this.formFields.btnHideCloseTicketSummary = true; 	//$('#closeTicketSummary').hide();
      this.formFields.isReleaseEquipRadioDisabled = true;
      this.formFields.isTSCommonButtonShow = true;
      this.formFields.isEquipmentReleasedForTreatmentFlag = obj.isEquipmentReleasedForTreatmentFlag

    }
    if (obj.ticketStatusId == TicketStatus.Void) {
      this.formFields.isValidTicketUser = false // Hide button of Save,Void and Cloase
    }
    //Division
    if(!this.divisionList.find(x=>x.value==obj.divisionMasterId))
    {
      this.divisionList.push({label:obj.divisionName,value:obj.divisionMasterId})
      this.formFields.selectedDivisionName=obj.divisionName
    }
    this.formFields.selectedDivisionId = obj.divisionMasterId
    //Region
    this.populateRegions(obj.divisionMasterId)
    if(!this.regionList.find(x=>x.value==obj.regionMasterId))
    {
      this.regionList.push({label:obj.regionName,value:obj.regionMasterId})
      this.formFields.selectedRegionName=obj.regionName
    }
    this.formFields.selectedRegionId = obj.regionMasterId

    //Facility 
    this.populateFacilities(obj.regionMasterId)
    this.formFields.selectedFacilityId = obj.facilityMasterId
    if(!this.facilityList.find(x=>x.value==obj.facilityMasterId))
    {
      this.facilityList.push({label:obj.facilityName,value:obj.facilityMasterId})
      this.formFields.selectedFacilityName=obj.facilityName
    }
    this.facilityChanged();
    this.formFields.isLocationBoxDisabled = true
    //this.formFields.batchRadioButtonselectedValue=0

    //////////////////////////////////////////	Batch Section 	//////////////////////////////////////////
    this.formFields.isCanBatchFlag = false;
    if (obj.isCanBatchFlag != null) {
      if (obj.isCanBatchFlag > 0) {
        this.formFields.isCanBatchFlag = true
      }
      if (obj.equipmentId <= 0) {
        if (obj.isCanBatchFlag == 0) {

          this.ticketInfoComponent.showEquipmentList()
          this.formFields.isShowColumn2 = false;
          this.formFields.isShowColumn3 = false
        }
        else {
          this.formFields.isShowColumn2 = true;
          this.formFields.isShowColumn3 = true
        }
      }
    }
    this.formFields.isCloneFlag = false;
    if (obj.isCloneFlag > 0) {
      this.formFields.isCloneFlag = true;
    }
 
    if (this.formFields.isBatchTicket) {
      this.formFields.batchRadioButtonselectedValue = 1
    }
    else {
      this.formFields.batchRadioButtonselectedValue = 0
    }
    this.formFields.batchRadioButtonselectedValue = 0
    this.createBatchRadioClick();
    this.processWorkTypes();
    //////////////////////////////////////////	SCHEDULED MAINTENANCE 	//////////////////////////////////////////
    if (obj.isScheduledFlag != null) {

      if (obj.isScheduledFlag == 1) {
        this.formFields.ScheduledRadioButtonselectedValue = "yes"
      }
      else {
        this.formFields.ScheduledRadioButtonselectedValue = "no"
      }

      this.populateWorkType();
    }

    if (obj.workTypeId != null) {
      this.formFields.selectedWorkTypeId = obj.workTypeId
      //this.formFields.selectedWorkTypeName = obj.workTypeDescription
      this.formFields.isServiceTypeBoxDisabled = true
      try
      {
        if (this.allWorkTypeList && this.formFields.selectedWorkTypeId) {
          this.formFields.selectedWorkTypeName = this.allWorkTypeList.find(x => x.WorkTypeId == this.formFields.selectedWorkTypeId).WorkTypeCode
        }
      }
      catch(ex)
      {

      }
    }

    if (obj.equipmentId) {
      this.formFields.SelectedEquipmentID = obj.equipmentId
      this.formFields.selectedEquipmentList =
      {
        EquipmentID: obj.equipmentId,
        EquipmentSerialNumber: obj.equipmentSerialNumber,
        EquipmentTypeDescription: obj.equipmentTypeDescription,
        EquipmentTypeID: obj.equipmentTypeId,
        ManufacturerName: obj.manufacturerName,
        ModelDescription: obj.modelDescription,
        ModelID: obj.modelId
      }

      //If the model does not have a clock, hide it
      this.formFields.hasclock = obj.hasClock
    }
    if (obj.DateServiceRequested != null) {
      this.formFields.srRequestedDate = this.datePiepe.transform(obj.DateServiceRequested, "MM/dd/yyyy");
      setTimeout(() => {
        this.formFields.selectedWorkTypeId=obj.workTypeId;
        if(!this.workTypeList.find(x=>x.value==obj.workTypeId))
        {
          this.workTypeList.push({label:obj.workTypeDescription,value:obj.workTypeId});
        }
        var workType = this.workTypeList.find(x => x.value == this.formFields.selectedWorkTypeId).label
        if (workType != 'PM') {
          this.formFields.isDateServiceRequestedDisabled = true;
        }
      }, 2000);

    }
    if (obj.DateClosed) {
      this.formFields.dateClosed = this.datePiepe.transform(obj.DateClosed, "MM/dd/yyyy");
    }
    if (obj.DateServiceBegan) {
      this.formFields.srBeginDate = this.datePiepe.transform(obj.DateServiceBegan, "MM/dd/yyyy");
    }

    if (obj.DateServicePerformed) {
      this.formFields.srCompletedDate = this.datePiepe.transform(obj.DateServicePerformed, "MM/dd/yyyy");
    }
    this.minutes = [];
    this.minutes.push({ label: "00", value: 0 }, { label: "15", value: 25 }, { label: "30", value: 50 }, { label: "45", value: 75 });
    if (obj.HoursWork) {
      //$('#hoursWork').val(ticket.hourswork[0]);
      let timeSplit = Number( obj.HoursWork).toFixed(2).toString().split('.');

      try {
        var hour = Number(timeSplit[0]);
        var min = Number(timeSplit[1]) ;
        if (min == undefined) { min = 0 }
        if (hour == undefined) { hour = 0 }
      }
      catch (err) {
        hour = obj.HoursWork;
        min = 0;
      }
      this.formFields.hoursWorkedSel = Number(hour)
      this.formFields.minutesWorkedSel = Number(min)

    }


    if (obj.HoursTravel) {
     
      let timeSplit = Number(obj.HoursTravel).toFixed(2).toString().split('.');
      try {
        hour = Number(timeSplit[0]);
        min = Number(timeSplit[1]);
        if (min == undefined) { min = 0 }
        if (hour == undefined) { hour = 0 }
      }
      catch (err) {
        hour = obj.HoursWork
        min = 0;
      }
      this.formFields.hoursTravelSel = Number(hour)
      this.formFields.minutesTravelSel = Number(min)
    }
    //Total Hours
    try {
      this.formFields.totalHours = Number(this.formFields.hoursWorkedSel) + Number(this.formFields.hoursTravelSel)
      this.formFields.totalMinutes = Number(this.minutes.find(x => x.value == this.formFields.minutesTravelSel).label) + Number(this.minutes.find(x => x.value == this.formFields.minutesWorkedSel).label)
      if(this.formFields.totalMinutes>=60)
      {
        this.formFields.totalHours=this.formFields.totalHours+1;
        this.formFields.totalMinutes=this.formFields.totalMinutes-60
      }
    }
    catch (ex) {
      console.log(ex);
    }
    if (obj.serviceRequested) {
      this.formFields.serviceRequested = obj.serviceRequested
    }
    if (obj.Findings) {
      this.formFields.findings = obj.Findings;
    }
    if (obj.isServiceMatchFindingsFlag!=null) {

      if (obj.isServiceMatchFindingsFlag == 1) {
        this.formFields.isServiceMatchFindingsFlag = "yes";
      }
      else {
        this.formFields.isServiceMatchFindingsFlag = "no";
      }
    }
    if (obj.WorkPerformed) {
      this.formFields.workPerformed = obj.WorkPerformed
    }
    //Additional Comment
    if(obj.additionalComments)
    {
      this.formFields.additionalComment=obj.additionalComments;
    }
    if (this.ticketInfoComponent) {
      //setTimeout('qualityCheck();',delay);
      this.ticketInfoComponent.getPayrollCodes();
      this.formFields.selectedpayRollId = obj.PayrollCodeID
      this.ticketInfoComponent.getSQACodes();
      this.formFields.selectedSQACodeId = obj.SQACodeId;
      this.ticketInfoComponent.SQACodeChanged();
      this.ticketInfoComponent.getSubSqaCodes();
      this.formFields.selectedSQASubCodeId = obj.SQASubCodeId;
      this.ticketInfoComponent.getQuestions();
    }


    if (obj.ClockHours) {
      this.formFields.clockHours = obj.ClockHours;
    }
    if (obj.lastClockHours) {
      this.formFields.lastRecordedHours = obj.lastClockHours;
    }
    if (obj.fullname.length > 0) {
      this.formFields.ticketSavedByFullName = obj.fullname
      this.formFields.ticketSavedByFirstLastName = obj.fullnamefirstlast
    }
    this.tkValidation.validateColumn1(true);
  }

  public loadTicketParts(ticketId) {
    var i = 0;
    var partTotal = 0;
    let getTicketPartsParam =
    {
      "GETTICKETPARTS": {
        TicketID: ticketId
      }
    }
    this._ticketService.getTicketParts(JSON.stringify(getTicketPartsParam)).subscribe(data => {
      if (data != null && data.length > 0) {
        this.formFields.partsUsedDuringRepair = data.filter
          (
            (thing, i, arr) => arr.findIndex(t => t.PartID === thing.PartID) === i
          ).
          map(data => ({
            quantity: data.Quantity,
            partId: data.PartID,
            partNumber: data.PartNumber,
            manufacturerName: data.manufacturerName,
            partDescription: data.partDescription,
            originalUnitCost: data.OriginalUnitCost,
            unitCost: data.UnitCost,
            dateOfInstall: this.datePiepe.transform(data.DateOfInstall, "MM/dd/yyyy"),
            isPartUnderWarranty: 0,
            rgaNumber: data.RGANumber,
            showRgaOptions: 1,//set this properly, at a later date -CH
            ticketPartSourceId: data.TicketPartSourceID,
            isReplacingWarrantyPartFlag: data.isReplacingWarrantyPartFlag,
            isRGAQualifiedFlag: data.isRGAQualifiedFlag,
            zeroCost:data.OriginalUnitCost!=data.UnitCost?true:false ,
          }));
      
        this.formFields.ispartsUsedRadio = "yes";
        // Added by satheesh
        if(this.formFields.partsUsedDuringRepair !=null && this.formFields.partsUsedDuringRepair !=undefined ){
          // let TotalAmount = this.formFields.partsUsedDuringRepair.filter(item => item.unitCost === item.unitCost)
          // .reduce((sum, current) => sum + current.unitCost, 0);
          let TotalAmount=0;
          this.formFields.partsUsedDuringRepair.forEach(obj => {
           TotalAmount +=obj.quantity*obj.unitCost
           });
          this.formFields.partTotalAmount = this.currencyPipe.transform(TotalAmount, '$');
        }
         

      }
      else {
        this.formFields.ispartsUsedRadio = "no";
      }
    },
      (error) => {
        console.log(error);
      }
    )
  }

  public loadTicketTestEquip(ticketId) {

    var i = 0;
    var testEquipTotal = 0;
    let getTestEquipmentParam =
    {
      "GETTICKETTESTEQUIP": {
        TicketID: ticketId
      }
    }
    this._ticketService.getTicketTestEquip(JSON.stringify(getTestEquipmentParam)).subscribe(data => {
      if (data != null && data.length > 0) {
        this.formFields.testEquipmentUsedDuringRepair = data.filter
          (
            (thing, i, arr) => arr.findIndex(t => t.equipmentId === thing.equipmentId) === i
          ).
          map(data => ({
            equipmentId: data.equipmentId,
            subType: data.EquipmentSubTypeCode,
            manufacturer: data.manufacturerName,
            modelNumber: data.ModelNumber,
            serialNumber: data.equipmentserialnumber,
            equipmentDescription: data.equipmentdescription,
            dateCalibrated: this.datePiepe.transform(data.dateCalibrated, "MM/dd/yyyy"),
            quantity: 0,
          }));
        testEquipTotal++;
        this.formFields.istestEquipUsedRadio = "yes";
        
      }
      else {
        this.formFields.istestEquipUsedRadio = "no";
      }
    },
      (error) => {
        console.log(error);
      }
    )
  }



  //#endregion



  public loadBatchDetails() //fillFromBatch
  {
    try {
      if (this.formFields.selectedBatchId) {
        this.formFields.batchDetails = null
        let getBatchDD =
        {
          "GETBATCHESDD": {
            BatchId: this.formFields.selectedBatchId
          }
        }
        this._batchService.getBatchesDD(JSON.stringify(getBatchDD)).subscribe(data => {
          if (data && data.batches && data.batches.length) {
            this.formFields.batchDetails = data.batches[0]
            this.loadBatchMeasure();
            this.loadBatchParts();
            if(this.formFields.TicketId==null)
            {
              this.formFields.serviceRequested = this.formFields.batchDetails.ServiceRequested
              this.formFields.findings = this.formFields.batchDetails.Findings
              this.formFields.workPerformed = this.formFields.batchDetails.WorkPerformed
            }

            //setupBatchEquipment();
            this.formFields.ScheduledRadioButtonselectedValue = "yes" // $("#isScheduledFlag1").attr("checked",true).click();
            setTimeout(() => {
              this.formFields.isServiceTypeBoxDisabled = true; //$("input[name=isScheduledFlagRadio]").attr("disabled",true);
            }, 1000);


            this.populateWorkTypeV2(1, '', '');  //getWorkTypes(1,'','');			// Reload all scheduled work types for batches
            if(this.formFields.TicketId==null && this.formFields.selectedWorkTypeId==null )
            {
              this.formFields.selectedWorkTypeId = this.formFields.batchDetails.WorkTypeId;
            }
            if (this.allWorkTypeList && this.formFields.selectedWorkTypeId) {
              this.formFields.selectedWorkTypeName = this.allWorkTypeList.find(x => x.WorkTypeId == this.formFields.selectedWorkTypeId).WorkTypeCode
            }


            this.formFields.selectedpayRollId = this.formFields.batchDetails.payrollCodeId;
            this.formFields.selectedSQACodeId = this.formFields.batchDetails.SQACodeId
            this.formFields.selectedSQASubCodeId = this.formFields.batchDetails.SQACodeId

            if (this.batchTicketInfoComponent) {
              this.batchTicketInfoComponent.getBatchFacilityEquipment();
            }

            this.formFields.isBatchTicket = true//BATCHTICKET = true;
          }
        },
          (error) => {
            console.log(error);
          }

        )
      }
    }
    catch (ex) {
      console.log(ex);
    }

  }
  public loadBatchMeasure() {
    try {
      this.formFields.batchMeasure = null;
      let getBatchMeasuresParam = {
        "GETBATCHMEASURES": {
          BatchId: this.formFields.batchDetails.BatchId,
          discreteMeasureId: null
        }
      }
      this._batchService.getBatchMeasures(JSON.stringify(getBatchMeasuresParam)).subscribe(data => {
        if (data && data.measures && data.measures.length) {
          this.formFields.batchMeasure = data.measures;
          //additional comment field [5]
          let checkForAdditionalComment = data.measures.find(x => x.discreteMeasureAttributeId == 5);    //commentObj = BATCHMEASURES[5];
          if (checkForAdditionalComment) 
          {
            if (checkForAdditionalComment.answer) {
              this.formFields.isShowAdditionalComment = true;
            }
          }
        }
      },
        (error) => {
          console.log(error)
        }
      )
    }
    catch (ex) {
      console.log(ex);
    }
  }
  public loadBatchParts() {
    try {
      this.formFields.batchPart = null;
      let getBatchPartParam = {
        "GETBATCHPARTS":
        {
          BatchId: this.formFields.batchDetails.BatchId,
          PartId: null
        }
      }
      this._batchService.getBatchParts(JSON.stringify(getBatchPartParam)).subscribe(data => {
        if (data && data.parts && data.parts.length) {
          this.formFields.batchPart = data.parts;
        }

      },
        (error) => {
          console.log(error)
        }
      )
    }
    catch (ex) {
      console.log(ex);
    }
  }

  public getPayrollCodes() {
    this._payrollCodeService.getPayrollCodes(null)
      .subscribe((Result: any) => {
        if (Result.length > 0) {
          this.paydata = Result.map(data => ({
            label: data.payrollCodeDescription,
            value: data.payrollCodeId,
          }));
        }
      },
        (respose: Response) => {
          // handle error here
        }
      );
  }
  public hoursWorkAndTravel(Type: string) {
    if (Type == "Hours") {
      this.formFields.totalHours = Number(this.formFields.hoursWorkedSel) + Number(this.formFields.hoursTravelSel)
    }
    else {
      this.minutes = [];
      this.minutes.push({ label: "00", value: 0 }, { label: "15", value: 25 }, { label: "30", value: 50 }, { label: "45", value: 75 });
      this.formFields.totalMinutes = Number(this.minutes.find(x => x.value == this.formFields.minutesTravelSel).label) + Number(this.minutes.find(x => x.value == this.formFields.minutesWorkedSel).label)
      if (this.formFields.totalMinutes >= 60) {
        this.formFields.totalHours = this.formFields.totalHours + 1;
        this.formFields.totalMinutes = this.formFields.totalMinutes - 60
      }
    }
  }
  public closeBatchButton() {
    // conform meessage
    this._confirmationService.confirm({
      message: 'Do you wish to close this batch ticket?\nYou cannot make further changes after this point.',
      accept: () => {
        this.showGlobalLoader=true;
        this._bartTicketSave.saveBatchTicket(true,(isSuccess)=>{
          setTimeout(() => {
            this.showGlobalLoader=false;
          }, 1000);
         
        });
      }
    });
  }
}
